"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const events_1 = require("~/utils/events");
const Command_1 = require("./Command");
const Viewer_1 = __importDefault(require("../Viewer"));
class ReplaceObjectsCommand extends Command_1.ViewerCommand {
    constructor(oldItemNumber, replacementItemNumber, objectsToBeReplacedUUIDs, typeOfItemToBeReplaced) {
        super();
        this.type = 'ReplaceObjectsCommand';
        this.oldItemNumber = oldItemNumber;
        this.replacementItemNumber = replacementItemNumber;
        this.objectsToBeReplacedUUIDs = objectsToBeReplacedUUIDs;
        this.typeOfItemToBeReplaced = typeOfItemToBeReplaced;
        this.name = `Replace Objects: ${this.objectsToBeReplacedUUIDs.map((uuid) => uuid).join('; ')}`;
    }
    // eslint-disable-next-line class-methods-use-this
    update() {
        // do nothing
    }
    executeWithHistory() {
        var _a, _b;
        (_b = (_a = Viewer_1.default.instance.getDesignProMain()) === null || _a === void 0 ? void 0 : _a.historyService) === null || _b === void 0 ? void 0 : _b.execute(this);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    execute(appliedFromHistory) {
        var _a, _b;
        if (!this.objectsToBeReplacedUUIDs.length || !this.replacementItemNumber) {
            return;
        }
        (_b = (_a = Viewer_1.default.instance.getDesignProMain()) === null || _a === void 0 ? void 0 : _a.historyService) === null || _b === void 0 ? void 0 : _b.emit(`${this.typeOfItemToBeReplaced}Replaced`, {
            replacementItemNumber: this.replacementItemNumber,
            objectsToBeReplacedUUIDs: this.objectsToBeReplacedUUIDs,
            typeOfItemToBeReplaced: this.typeOfItemToBeReplaced,
        });
        const eventPayload = {
            itemNumber: this.replacementItemNumber,
            uuids: [...this.objectsToBeReplacedUUIDs],
        };
        document.body.dispatchEvent((0, events_1.replaceCurrentProjectItemsEvent)(eventPayload));
    }
    // eslint-disable-next-line class-methods-use-this
    undo() {
        new ReplaceObjectsCommand(this.replacementItemNumber, this.oldItemNumber, this.objectsToBeReplacedUUIDs, this.typeOfItemToBeReplaced).execute(false);
    }
    // eslint-disable-next-line class-methods-use-this
    toJSON() {
        return {
            type: this.type,
            id: this.id,
            name: this.name,
            replacementItemNumber: this.replacementItemNumber,
            objectsToBeReplacedUUIDs: this.objectsToBeReplacedUUIDs,
        };
    }
    // eslint-disable-next-line class-methods-use-this
    fromJSON(json) {
        this.replacementItemNumber = json.replacementItemNumber;
        this.objectsToBeReplacedUUIDs = json.objectsToBeReplacedUUIDs;
    }
}
exports.default = ReplaceObjectsCommand;
